<template>
    <div :style="actionBarStyles" class="c-catalog-action-bar">
        <slot></slot>
    </div>
</template>

<script setup>
import { computed } from 'vue';

import { useState } from '~coreModules/core/js/composables/vuexHelpers';

import { HEADER_MODULE_NAME } from '~coreModules/header/js/header-store';

const { headerHeight } = useState(HEADER_MODULE_NAME, [
    'headerHeight',
]);

const actionBarStyles = computed(() => {
    const styles = {
        top: headerHeight.value && `${headerHeight.value}px`,
    };

    return styles;
});
</script>

<style lang="scss">

    .c-catalog-action-bar {
        position: sticky;
        width: 100%;
        padding: $nu-spacer-1pt5 $nu-spacer-2;
        z-index: map-get($zindex, catalog-action-bar);
        background-color: $nu-secondary;
    }

</style>
